import { useToastStore } from "../store/toast-store";
import type { ToastApi, ToastPosition } from "../store/toast-store";

/**
 * Toast aksiyonları — modül seviyesinde sabit bir nesne.
 *
 * Store'a ABONE OLMAZ. Zustand aksiyonları store ömrü boyunca değişmediği için
 * her çağrıda getState() üzerinden okumak güvenli, ve karşılığında toast state'i
 * değiştiğinde useToast() kullanan yüzlerce bileşen yeniden render edilmiyor.
 */
const toastApi: ToastApi = {
  addToast: (input) => useToastStore.getState().addToast(input),
  removeToast: (id) => useToastStore.getState().removeToast(id),
  updateToast: (id, updates) => useToastStore.getState().updateToast(id, updates),
  clearAllToasts: () => useToastStore.getState().clearAllToasts(),

  success: (message, options) => useToastStore.getState().success(message, options),
  error: (message, options) => useToastStore.getState().error(message, options),
  warning: (message, options) => useToastStore.getState().warning(message, options),
  info: (message, options) => useToastStore.getState().info(message, options),
  loading: (message, options) => useToastStore.getState().loading(message, options),

  promise: (promise, messages, options) =>
    useToastStore.getState().promise(promise, messages, options),

  setPosition: (position) => useToastStore.getState().setPosition(position),
  setMaxToasts: (max) => useToastStore.getState().setMaxToasts(max),
};

/** React bileşenleri ve hook'lar için toast API'si. */
export const useToast = (): ToastApi => toastApi;

/**
 * React dışından (interceptor, servis, store) toast göstermek için.
 * useToast() ile birebir aynı API.
 */
export const toast = toastApi;

/** Yalnızca ToastContainer içindir: görünen toast listesine abone olur. */
export const useVisibleToasts = () => useToastStore((state) => state.toasts);

/** Yalnızca ToastContainer içindir: varsayılan pozisyona abone olur. */
export const useDefaultToastPosition = (): ToastPosition =>
  useToastStore((state) => state.position);
